import React, { useEffect, useState } from 'react';
import { Row, Col, Card, FormGroup } from 'react-bootstrap';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import SFDetails from './fromFormComponents/SFDetails';
import * as action from '../store/POTemplate.action';
import { usePOTemplateState } from '../P.O.TemplateContext/index';

function SupplierFactoryDetails({ element, eleIndex, fromForm, itemDragging }) {
  const [factoryData, setFactoryData] = useState(null);
  const { duplicatingItem, deleteItem, editingInput, changeLabel, dropLocation, dropInLocation, deleteCard, modfiyReqAndEnable, inSave } = usePOTemplateState();

  const dispatch = useDispatch();
  const {
    poTemplateData: { factData },
  } = useSelector((reduxState) => reduxState);

  useEffect(() => {
    if (!isEmpty(element)) {
      setFactoryData({ ...element });
    }
  }, [element]);

  const editSF = () => {
    modfiyReqAndEnable(factoryData, eleIndex);
  };

  const onChangeFact = (value, label, i, eleIndex, index) => {
    const template = [...(factoryData?.columns || [])];
    if (template[index][i].options) {
      const updatedOptions = template[index][i].options.map((e) => {
        if (e.name === label) {
          return { ...e, value };
        }
        return e;
      });
      template[index][i].options = updatedOptions;
    } else {
      template[index][i].value = value;
    }
    setFactoryData((previosState) => ({
      ...previosState,
      columns: template,
    }));
  };

  useEffect(() => {
    if (inSave && factoryData && !factData) {
      dispatch(action.factoryUpdate(factoryData));
    }
  }, [inSave, factoryData, dispatch, factData]);

  const changePosition = (item, index, i) => {
    const dragedItem = item?.col;
    const newColumns = factoryData?.columns;
    newColumns[index].splice(i, 0, dragedItem);
    if (newColumns[item?.index][item?.i]?.id === newColumns[index][i]?.id) {
      newColumns[item?.index].splice(item?.i, 1); // very Important to be after new item is added
    } else {
      newColumns[item?.index].splice(item?.i + 1, 1);
    }

    setFactoryData((previousData) => ({
      ...previousData,
      columns: newColumns,
    }));
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <Card className="listing-card">
        <Card.Header className={fromForm ? 'px-2 py-2 bgcolor-dark d-flex rounded-0' : 'px-2 py-2 bgcolor-dark rounded-0'}>
          <strong onClick={() => changeLabel(factoryData, eleIndex)}>{factoryData?.label}</strong>
          {fromForm && itemDragging?.type !== 'container' && (
            <>
              <button className="btn btn-border ml-auto  py-0 px-1" name="edit" type="button" key={`${element?.label}_${eleIndex}_edit`} onClick={editSF}>
                <span className="icon-edit" />
              </button>
              <button
                className="btn btn-border  py-0 px-1"
                onClick={() => deleteCard(eleIndex)}
                name="delete"
                type="button"
                key={`${element?.label}_${eleIndex}_delete`}
              >
                <span className="icon-delete" />
              </button>
            </>
          )}
        </Card.Header>
        {itemDragging?.type !== 'container' && (
          <Card.Body className="py-4">
            <Row className="span_font_size">
              {factoryData?.columns?.map((column, index) => {
                return (
                  <Col lg={6} key={`columns_${index}`}>
                    {column.map((col, i) => {
                      return (
                        <FormGroup key={`${col?.id}_colEle`}>
                          <SFDetails
                            col={col}
                            i={i}
                            index={index}
                            dropLocation={dropLocation}
                            changePosition={changePosition}
                            dropInLocation={dropInLocation}
                            fromForm={fromForm}
                            duplicatingItem={duplicatingItem}
                            editingInput={editingInput}
                            onChange={onChangeFact}
                            factoryData={factoryData}
                            eleIndex={eleIndex}
                            deleteItem={deleteItem}
                          />
                        </FormGroup>
                      );
                    })}
                  </Col>
                );
              })}
            </Row>
          </Card.Body>
        )}
      </Card>
    </DndProvider>
  );
}

export default SupplierFactoryDetails;
